import { Helmet } from "react-helmet-async";

import { useGetUnreadNotificationsCountQuery } from "@/redux/service.js";

const POLLING_INTERVAL = 30000;
const MAX_DISPLAYED_COUNT = 99;

/**
 * Prefixes the browser tab title with the unread notifications count,
 * e.g. "(3) PRME Commons". Renders nothing while there is nothing unread.
 */
const NotificationsTabBadge = () => {
  const { data } = useGetUnreadNotificationsCountQuery(undefined, {
    pollingInterval: POLLING_INTERVAL,
  });
  const unreadCount = data?.count ?? 0;

  if (unreadCount <= 0) return null;

  const label =
    unreadCount > MAX_DISPLAYED_COUNT
      ? `${MAX_DISPLAYED_COUNT}+`
      : `${unreadCount}`;

  return <Helmet titleTemplate={`(${label}) %s`} />;
};

export default NotificationsTabBadge;
